import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService as AuthGuard} from './framework/services/auth-guard.service';
import {GuidesComponent} from './guides/guides.component';

const routes: Routes = [
    { path: '',
    redirectTo: 'miwap',
    pathMatch: 'full' },
    {
        path: 'miwap',
        loadChildren: () => import('./miwap/miwap.module').then(m => m.MiwapModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'kobra',
        loadChildren: () => import('./kobra/kobra.module').then(m => m.KobraModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'horch',
        loadChildren: () => import('./horch/horch.module').then(m => m.HorchModule),
        canActivate: [AuthGuard]
    }
    ,
    {
        path: 'lip',
        loadChildren: () => import('./lip/lip.module').then(m => m.LipModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'logilearn',
        component: GuidesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'login'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
